function initWork() {
  const workMainVariants = document.querySelector(".work-main__variants");
  if (!workMainVariants) return;

  const workMainVariantsSwiper = new Swiper(workMainVariants, {
    slidesPerView: 3,
    spaceBetween: 20,
    navigation: {
      nextEl: ".work-main__variants .swiper-next-btn",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });

  const workMainAboutSlider = document.querySelector(".work-main__about-slider");
  if (!workMainAboutSlider) return;

  const workMainAboutSliderSwiper = new Swiper(workMainAboutSlider, {
    slidesPerView: 5,
    spaceBetween: 20,
    navigation: {
      nextEl: ".work-main__about-slider .swiper-next-btn",
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  });
}

export { initWork };
